import Icon from 'components/Icons/Icon';
import PracticeTitle from 'components/Practice/PracticeTitle';
import { useDispatch, useSelector } from 'react-redux';
import React from 'react';
import { useTranslate } from 'react-translate';
// reactstrap components
import { Card, CardBody, CardHeader } from 'reactstrap';
import PractitionerForm from 'components/Practice/Form/PractitionerForm';


const PracticeEditPractitioner = () => {
  const t = useTranslate('practices');
  const practitioner = useSelector(state => state.practicesReducer.practitionerData);

  return (
    <Card>
      <CardBody>
        <Card>
          <CardHeader className="d-flex ">
            <PracticeTitle title={`${t("practitioner")}: ${practitioner.firstName} ${practitioner.lastName}`}/>
          </CardHeader>
          <CardBody>
            <Card className="border-0 shadow-none">
              <CardBody>
                <PractitionerForm />
              </CardBody>
            </Card>
          </CardBody>
        </Card>
      </CardBody>
    </Card>
  );
};

export default PracticeEditPractitioner;
